import React, { useCallback, useEffect, useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';

import { girisYapilmis } from '../services/authApi';
import { fiyatAkisiAc } from '../services/isyatirimApi';
import { fiyatFormatla, isaretliFormatla, degisimHesapla } from '../utils/fiyat';

const LOGO_YOLU = 'M4 18l5-6 4 3 7-9M16 6h4v4';

function Logo({ className }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.2" d={LOGO_YOLU} />
    </svg>
  );
}

const HIZMETLER = [
  {
    baslik: 'BİST Hisse Takibi',
    aciklama: 'Borsa İstanbul şirketlerini bilanço, değerleme, sektör görünümü ve teknik göstergelerle düzenli olarak izliyoruz.',
    iconBg: 'bg-invest-100 text-invest-700 group-hover:bg-invest-700 group-hover:text-white',
    yollar: ['M4 18l5-6 4 3 7-9M16 6h4v4']
  },
  {
    baslik: 'Portföy Oluşturma',
    aciklama: 'Yatırım süresi, likidite ihtiyacı ve risk toleransına göre dengeli portföy dağılımları tasarlıyoruz.',
    iconBg: 'bg-cyan-100 text-cyan-700 group-hover:bg-cyan-700 group-hover:text-white',
    yollar: ['M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z', 'M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z']
  },
  {
    baslik: 'Yatırım Danışmanlığı',
    aciklama: 'Yatırım hedeflerini, piyasa koşullarını ve riskleri birlikte değerlendirerek kişiye özel yol haritası oluşturuyoruz.',
    iconBg: 'bg-violet-100 text-violet-700 group-hover:bg-violet-700 group-hover:text-white',
    yollar: ['M9 17v-2a4 4 0 014-4h4m0 0-3-3m3 3-3 3M5 3h6a2 2 0 012 2v4M5 21h6a2 2 0 002-2v-4H5a2 2 0 01-2-2V5a2 2 0 012-2z']
  },
  {
    baslik: 'Şirket ve Sektör Analizi',
    aciklama: 'Şirket finansallarını, sektör dinamiklerini ve makroekonomik etkileri bir arada değerlendiriyoruz.',
    iconBg: 'bg-amber-100 text-amber-700 group-hover:bg-amber-600 group-hover:text-white',
    yollar: ['M9 17v-6h6v6m-9 4h12a2 2 0 002-2V9l-8-6-8 6v10a2 2 0 002 2z']
  },
  {
    baslik: 'Risk Yönetimi',
    aciklama: 'Yoğunlaşma, volatilite, likidite ve zarar toleransı gibi risk başlıklarını düzenli olarak takip ediyoruz.',
    iconBg: 'bg-rose-100 text-rose-700 group-hover:bg-rose-700 group-hover:text-white',
    yollar: ['M12 8c-2.21 0-4 1.343-4 3s1.79 3 4 3 4 1.343 4 3-1.79 3-4 3m0-12V5m0 15v-3']
  },
  {
    baslik: 'Raporlama',
    aciklama: 'Takip edilen varlıklar, portföy dağılımı ve piyasa gelişmeleri hakkında anlaşılır raporlar hazırlıyoruz.',
    iconBg: 'bg-sky-100 text-sky-700 group-hover:bg-sky-700 group-hover:text-white',
    yollar: ['M9 12h6m-6 4h6M7 3h7l5 5v13H7a2 2 0 01-2-2V5a2 2 0 012-2z']
  }
];

const ARASTIRMALAR = [
  {
    etiket: 'HAFTALIK BÜLTEN',
    baslik: 'BİST Haftalık Görünüm',
    kategori: 'Piyasa stratejisi',
    aciklama: 'Endeks görünümü, öne çıkan sektörler ve haftanın önemli veri gündemi.',
    gradient: 'from-invest-950 via-invest-800 to-invest-500'
  },
  {
    etiket: 'ŞİRKET ANALİZİ',
    baslik: 'Finansal Sonuç Notu',
    kategori: 'Temel analiz',
    aciklama: 'Bilanço performansı, kârlılık görünümü ve değerleme çerçevesi.',
    gradient: 'from-slate-950 via-slate-800 to-cyan-600'
  },
  {
    etiket: 'EĞİTİM',
    baslik: 'Portföy Riskini Anlamak',
    kategori: 'Yatırımcı eğitimi',
    aciklama: 'Çeşitlendirme, volatilite ve risk-getiri ilişkisinin temel noktaları.',
    gradient: 'from-slate-950 via-violet-900 to-invest-600'
  }
];

const SSS = [
  {
    soru: 'Portföy oluşturulurken hangi bilgiler dikkate alınır?',
    cevap: 'Yatırım hedefi, yatırım süresi, gelir yapısı, likidite ihtiyacı, risk toleransı ve mevcut yatırımlar birlikte değerlendirilir.'
  },
  {
    soru: 'BİST hisseleri hangi sıklıkla takip edilir?',
    cevap: 'Şirket haberleri, finansal sonuçlar ve önemli piyasa gelişmeleri düzenli olarak izlenir; raporlama sıklığı seçilen hizmet kapsamına göre belirlenir.'
  },
  {
    soru: 'Yatırımlarda getiri garantisi veriliyor mu?',
    cevap: 'Hayır. Sermaye piyasası araçları değer kaybedebilir. Amaç, riskleri görünür kılan disiplinli ve izlenebilir bir yatırım süreci oluşturmaktır.'
  }
];

function useKimlikDurumu() {
  const [, setTick] = useState(0);

  useEffect(() => {
    function guncelle() {
      setTick(t => t + 1);
    }
    window.addEventListener('auth-changed', guncelle);
    window.addEventListener('storage', guncelle);
    return () => {
      window.removeEventListener('auth-changed', guncelle);
      window.removeEventListener('storage', guncelle);
    };
  }, []);

  return girisYapilmis();
}

function GirisCta({ className }) {
  const girisli = useKimlikDurumu();

  return girisli ? (
    <NavLink to="/takip-listem" className={className}>Takip Listem</NavLink>
  ) : (
    <NavLink to="/login" className={className}>Müşteri Girişi</NavLink>
  );
}

// BIST 100 (XU100) endeksini panelde göstermek için. isyatirim.com.tr
// ulaşılamazsa sessizce eski değeri (ya da hiç veri gelmediyse null'ı)
// korur; pazarlama sayfasında hata mesajı göstermeye gerek yok.
function useXu100() {
  const [xu100, setXu100] = useState({ last: null, dayClose: null });

  useEffect(() => {
    return fiyatAkisiAc(['XU100'], (kod, veri) => {
      setXu100({ last: veri.last, dayClose: veri.dayClose });
    });
  }, []);

  return xu100;
}

function SalavatKart({
  renk, baslik, aciklama, iconYolu, katilimciSayisi, salavatSayisi, hedef, ilerlemeYuzdesi,
  formData, alanlar, gonderildi, onSubmit, formRef, butonMetni
}) {
  const vurguRenk = renk === 'amber' ? 'amber' : 'invest';

  return (
    <article className={`overflow-hidden rounded-[2rem] border shadow-panel ${renk === 'amber' ? 'border-amber-200 bg-gradient-to-br from-amber-50 via-white to-white' : 'border-invest-200 bg-gradient-to-br from-invest-50 via-white to-white'}`}>
      <div className={`border-b p-7 text-white sm:p-8 ${renk === 'amber' ? 'border-amber-100 bg-slate-950' : 'border-invest-100 bg-invest-950'}`}>
        <div className="flex items-start justify-between gap-5">
          <div>
            <p className={`text-xs font-black uppercase tracking-[0.2em] ${renk === 'amber' ? 'text-amber-300' : 'text-invest-300'}`}>Salavat Zinciri</p>
            <h3 className="mt-3 text-2xl font-black sm:text-2xl">{baslik}</h3>
            <p className="mt-3 max-w-xl leading-7 text-slate-300">{aciklama}</p>
          </div>
          <span className={`grid h-14 w-14 shrink-0 place-items-center rounded-2xl bg-white/10 ${renk === 'amber' ? 'text-amber-300' : 'text-invest-300'}`}>
            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.2" d={iconYolu} />
            </svg>
          </span>
        </div>
      </div>

      <div className="p-7 sm:p-8">
        <div className="grid gap-4 sm:grid-cols-3">
          <div className="rounded-2xl bg-slate-50 p-5">
            <p className="text-xs font-black uppercase tracking-wider text-slate-500">Katılımcı</p>
            <p className="mt-2 text-3xl font-black text-slate-950">{katilimciSayisi}</p>
          </div>
          <div className="rounded-2xl bg-slate-50 p-5">
            <p className="text-xs font-black uppercase tracking-wider text-slate-500">Toplam Salavat</p>
            <p className={`mt-2 text-3xl font-black ${vurguRenk === 'amber' ? 'text-amber-700' : 'text-invest-700'}`}>{salavatSayisi}</p>
          </div>
          <div className="rounded-2xl bg-slate-50 p-5">
            <p className="text-xs font-black uppercase tracking-wider text-slate-500">Hedef</p>
            <p className="mt-2 text-3xl font-black text-slate-950">{hedef}</p>
          </div>
        </div>

        <div className="mt-6">
          <div className="mb-2 flex items-center justify-between text-xs font-black uppercase tracking-wider">
            <span className="text-slate-500">İlerleme</span>
            <span className={vurguRenk === 'amber' ? 'text-amber-700' : 'text-invest-700'}>%{ilerlemeYuzdesi}</span>
          </div>
          <div className="h-3 overflow-hidden rounded-full bg-slate-100">
            <div
              className={`h-full rounded-full transition-all duration-500 ${vurguRenk === 'amber' ? 'bg-amber-500' : 'bg-invest-600'}`}
              style={{ width: `${ilerlemeYuzdesi}%` }}
            />
          </div>
        </div>

        <form ref={formRef} onSubmit={onSubmit} className="mt-7 grid gap-4">
          {alanlar}

          <button
            type="submit"
            className={`inline-flex items-center justify-center rounded-xl px-6 py-4 font-black text-white transition ${renk === 'amber' ? 'bg-slate-950 hover:bg-amber-600' : 'bg-invest-700 hover:bg-invest-800'}`}
          >
            {butonMetni}
          </button>

          {gonderildi && (
            <p className="rounded-xl bg-emerald-50 px-4 py-3 text-sm font-bold text-emerald-700">
              Katılımınız zincire eklendi.
            </p>
          )}
        </form>
      </div>
    </article>
  );
}

function Home() {
  const xu100 = useXu100();
  const xu100Degisim = xu100.last !== null ? degisimHesapla(xu100.last, xu100.dayClose) : null;

  const [mobilMenuAcik, setMobilMenuAcik] = useState(false);
  const [iletisimGonderildi, setIletisimGonderildi] = useState(false);
  const [endeksGonderildi, setEndeksGonderildi] = useState(false);
  const [hisseGonderildi, setHisseGonderildi] = useState(false);

  const iletisimFormRef = useRef(null);
  const endeksFormRef = useRef(null);
  const hisseFormRef = useRef(null);

  function iletisimGonder(event) {
    event.preventDefault();
    setIletisimGonderildi(true);
    iletisimFormRef.current.reset();
  }

  function endeksZinciriGonder(event) {
    event.preventDefault();
    setEndeksGonderildi(true);
    endeksFormRef.current.reset();
  }

  function hisseZinciriGonder(event) {
    event.preventDefault();
    setHisseGonderildi(true);
    hisseFormRef.current.reset();
  }

  return (
    <div className="bg-white text-slate-800 antialiased">
      <header className="sticky top-0 z-50 border-b border-slate-200/80 bg-white/90 backdrop-blur-xl">
        <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
          <a href="#anasayfa" className="flex items-center gap-3" aria-label="Kaldır Yatırım Danışmanlık ana sayfa">
            <span className="grid h-12 w-12 place-items-center rounded-2xl bg-invest-700 text-white shadow-lg shadow-invest-700/20">
              <Logo className="h-7 w-7" />
            </span>
            <span>
              <span className="block text-lg font-black leading-none text-slate-950">Kaldır Yatırım</span>
              <span className="mt-1 block text-[10px] font-black uppercase tracking-[0.16em] text-invest-700">Danışmanlık</span>
            </span>
          </a>

          <nav className="hidden items-center gap-7 lg:flex" aria-label="Ana menü">
            <a href="#hizmetler" className="text-sm font-bold text-slate-600 transition hover:text-invest-700">Hizmetler</a>
            <a href="#yaklasim" className="text-sm font-bold text-slate-600 transition hover:text-invest-700">Yatırım Yaklaşımı</a>
            <a href="#portfoy" className="text-sm font-bold text-slate-600 transition hover:text-invest-700">Portföy Süreci</a>
            <a href="#arastirma" className="text-sm font-bold text-slate-600 transition hover:text-invest-700">Araştırma</a>
            <a href="#sss" className="text-sm font-bold text-slate-600 transition hover:text-invest-700">S.S.S.</a>
          </nav>

          <div className="hidden items-center gap-3 md:flex">
            <GirisCta className="rounded-xl border border-slate-300 px-5 py-3 text-sm font-black text-slate-700 transition hover:border-invest-300 hover:text-invest-700" />
            <a href="#iletisim" className="rounded-xl bg-invest-700 px-5 py-3 text-sm font-black text-white shadow-lg shadow-invest-700/20 transition hover:-translate-y-0.5 hover:bg-invest-800">
              Görüşme Planla
            </a>
          </div>

          <button
            type="button"
            onClick={() => setMobilMenuAcik(acik => !acik)}
            className="grid h-11 w-11 place-items-center rounded-xl border border-slate-200 text-slate-700 md:hidden"
            aria-label="Menüyü aç"
            aria-expanded={mobilMenuAcik}
          >
            {mobilMenuAcik ? (
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 6l12 12M18 6L6 18" />
              </svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 7h16M4 12h16M4 17h16" />
              </svg>
            )}
          </button>
        </div>

        {mobilMenuAcik && (
          <div className="border-t border-slate-100 bg-white px-4 py-5 md:hidden">
            <nav className="mx-auto flex max-w-7xl flex-col gap-2">
              <a href="#hizmetler" onClick={() => setMobilMenuAcik(false)} className="rounded-xl px-4 py-3 font-bold text-slate-700 hover:bg-slate-50">Hizmetler</a>
              <a href="#yaklasim" onClick={() => setMobilMenuAcik(false)} className="rounded-xl px-4 py-3 font-bold text-slate-700 hover:bg-slate-50">Yatırım Yaklaşımı</a>
              <a href="#portfoy" onClick={() => setMobilMenuAcik(false)} className="rounded-xl px-4 py-3 font-bold text-slate-700 hover:bg-slate-50">Portföy Süreci</a>
              <a href="#arastirma" onClick={() => setMobilMenuAcik(false)} className="rounded-xl px-4 py-3 font-bold text-slate-700 hover:bg-slate-50">Araştırma</a>
              <GirisCta className="rounded-xl px-4 py-3 font-bold text-slate-700 hover:bg-slate-50" />
              <a href="#iletisim" onClick={() => setMobilMenuAcik(false)} className="mt-2 rounded-xl bg-invest-700 px-4 py-3 text-center font-black text-white">Görüşme Planla</a>
            </nav>
          </div>
        )}
      </header>

      <main>
        <section id="anasayfa" className="market-grid relative overflow-hidden from-invest-50 via-white to-white py-20 lg:py-28">
          <div className="absolute -right-28 top-10 h-96 w-96 rounded-full bg-invest-200/60 blur-3xl"></div>
          <div className="absolute -left-36 bottom-0 h-80 w-80 rounded-full bg-cyan-200/40 blur-3xl"></div>

          <div className="relative mx-auto grid max-w-7xl items-center gap-14 px-4 sm:px-6 lg:grid-cols-[1.02fr_0.98fr] lg:px-8">
            <div>
              <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-invest-200 bg-white px-4 py-2 text-sm font-black text-invest-800 shadow-sm">
                <span className="h-2 w-2 animate-pulse rounded-full bg-emerald-500"></span>
                Veriye dayalı, disiplinli yatırım yaklaşımı
              </div>

              <h1 className="max-w-3xl text-4xl font-black leading-tight tracking-tight text-slate-950 sm:text-5xl lg:text-6xl">
                Yatırım kararlarınız için
                <span className="text-invest-700"> analiz, strateji</span>
                {' '}ve düzenli takip.
              </h1>

              <p className="mt-7 max-w-2xl text-lg leading-8 text-slate-600">
                Kaldır Yatırım Danışmanlık olarak Borsa İstanbul şirketlerini temel ve teknik göstergelerle izliyor,
                yatırım hedefiniz ile risk profilinize uygun portföy stratejileri oluşturuyoruz.
              </p>

              <div className="mt-9 flex flex-col gap-4 sm:flex-row">
                <a href="#iletisim" className="inline-flex items-center justify-center gap-2 rounded-xl bg-invest-700 px-7 py-4 text-base font-black text-white shadow-xl shadow-invest-700/20 transition hover:-translate-y-1 hover:bg-invest-800">
                  Yatırımcı Profilinizi Oluşturun
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 12h14m-6-6 6 6-6 6" />
                  </svg>
                </a>
                <a href="#hizmetler" className="inline-flex items-center justify-center rounded-xl border border-slate-300 bg-white px-7 py-4 text-base font-black text-slate-700 transition hover:border-invest-300 hover:text-invest-700">
                  Hizmetleri İnceleyin
                </a>
              </div>

              <div className="mt-10 grid max-w-xl grid-cols-2 gap-4 sm:grid-cols-3">
                <div>
                  <p className="text-2xl font-black text-slate-950">BİST</p>
                  <p className="mt-1 text-sm font-semibold text-slate-500">Şirket ve sektör takibi</p>
                </div>
                <div>
                  <p className="text-2xl font-black text-slate-950">360°</p>
                  <p className="mt-1 text-sm font-semibold text-slate-500">Portföy değerlendirmesi</p>
                </div>
                <div className="col-span-2 sm:col-span-1">
                  <p className="text-2xl font-black text-slate-950">Düzenli</p>
                  <p className="mt-1 text-sm font-semibold text-slate-500">Rapor ve bilgilendirme</p>
                </div>
              </div>
            </div>

            <div className="relative">
              <div className="absolute -inset-5 rounded-[2.25rem] bg-gradient-to-br from-invest-300/50 to-cyan-200/40 blur-2xl"></div>

              <div className="relative overflow-hidden rounded-[2rem] border border-slate-800 bg-slate-950 p-3 shadow-panel">
                <div className="rounded-[1.45rem] bg-gradient-to-br from-slate-900 to-invest-950 p-6 sm:p-8">
                  <div className="flex items-start justify-between gap-4">
                    <div>
                      <p className="text-sm font-bold text-invest-300">Piyasa Görünümü</p>
                      <h2 className="mt-1 text-2xl font-black text-white">BİST Takip Paneli</h2>
                    </div>
                    <span className="rounded-xl border border-white/10 bg-white/5 px-3 py-2 text-xs font-bold text-slate-300">ÖRNEK</span>
                  </div>

                  <div className="mt-8 rounded-2xl border border-white/10 bg-white/5 p-5">
                    <div className="flex items-end justify-between">
                      <div>
                        <p className="text-xs font-bold uppercase tracking-wider text-slate-400">BIST 100 Endeksi</p>
                        <p className="mt-2 text-3xl font-black text-white">
                          {xu100.last !== null ? fiyatFormatla(xu100.last) : '00.000,00'}
                        </p>
                      </div>
                      <p className={
                        'rounded-full px-3 py-1 text-sm font-black ' +
                        (xu100Degisim && xu100Degisim.fark < 0 ? 'bg-red-400/10 text-red-400' : 'bg-emerald-400/10 text-emerald-400')
                      }>
                        {xu100Degisim ? isaretliFormatla(xu100Degisim.yuzde, '%') : '+%0,00'}
                      </p>
                    </div>

                    <div className="mt-8 flex h-36 items-end gap-2" aria-label="Temsili piyasa grafiği">
                      <span className="h-[34%] flex-1 rounded-t bg-invest-900"></span>
                      <span className="h-[47%] flex-1 rounded-t bg-invest-800"></span>
                      <span className="h-[42%] flex-1 rounded-t bg-invest-800"></span>
                      <span className="h-[58%] flex-1 rounded-t bg-invest-700"></span>
                      <span className="h-[51%] flex-1 rounded-t bg-invest-700"></span>
                      <span className="h-[66%] flex-1 rounded-t bg-invest-600"></span>
                      <span className="h-[61%] flex-1 rounded-t bg-invest-600"></span>
                      <span className="h-[78%] flex-1 rounded-t bg-invest-500"></span>
                      <span className="h-[72%] flex-1 rounded-t bg-invest-500"></span>
                      <span className="h-[88%] flex-1 rounded-t bg-invest-400"></span>
                      <span className="h-[82%] flex-1 rounded-t bg-invest-400"></span>
                      <span className="h-full flex-1 rounded-t bg-invest-300"></span>
                    </div>
                  </div>

                  <div className="mt-4 grid grid-cols-3 gap-3">
                    <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
                      <p className="text-xs text-slate-400">Takip Listesi</p>
                      <p className="mt-1 text-xl font-black text-white">24</p>
                      <p className="mt-1 text-[11px] text-slate-500">örnek şirket</p>
                    </div>
                    <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
                      <p className="text-xs text-slate-400">Sektör</p>
                      <p className="mt-1 text-xl font-black text-white">12</p>
                      <p className="mt-1 text-[11px] text-slate-500">izlenen alan</p>
                    </div>
                    <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
                      <p className="text-xs text-slate-400">Rapor</p>
                      <p className="mt-1 text-xl font-black text-white">4</p>
                      <p className="mt-1 text-[11px] text-slate-500">rapor türü</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="absolute -bottom-7 -left-6 hidden max-w-xs rounded-2xl border border-slate-200 bg-white p-4 shadow-xl sm:block">
                <p className="text-xs font-black uppercase tracking-wider text-invest-700">Risk odaklı yaklaşım</p>
                <p className="mt-1 text-sm leading-6 text-slate-600">Portföy önerileri, yatırımcının risk profili ve hedefleri dikkate alınarak değerlendirilir.</p>
              </div>
            </div>
          </div>
        </section>

        <section id="salavat-zinciri" className="bg-white py-20 lg:py-24">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="mx-auto max-w-3xl text-center">
              <p className="text-sm font-black uppercase tracking-[0.22em] text-invest-700">Salavat Zincirleri</p>
              <h2 className="mt-4 text-3xl font-black tracking-tight text-slate-950 sm:text-4xl">
                Zincire katıl, hedefe birlikte ulaşalım
              </h2>
              <p className="mt-5 text-lg leading-8 text-slate-600">
                Aşağıdaki salavat zincirlerinden birine katılarak niyetinizi paylaşabilir,
                toplam katılım sayısını anlık olarak artırabilirsiniz.
              </p>
            </div>

            <div className="mt-14 grid gap-8 lg:grid-cols-2">
              <SalavatKart
                renk="invest"
                baslik="Endeksi Kaldırma salavat zincirine katıl"
                aciklama="BİST endeksinin yükselişi için oluşturulan ortak salavat zincirine katılın."
                iconYolu="M4 18l5-6 4 3 7-9M16 6h4v4"
                katilimciSayisi="1.248"
                salavatSayisi="124.800"
                hedef="200.000"
                ilerlemeYuzdesi={62}
                gonderildi={endeksGonderildi}
                onSubmit={endeksZinciriGonder}
                formRef={endeksFormRef}
                butonMetni="Endeks Zincirine Katıl"
                alanlar={(
                  <div className="grid gap-4 sm:grid-cols-2">
                    <div>
                      <label htmlFor="index-name" className="mb-2 block text-sm font-black text-slate-700">Adınız Soyadınız</label>
                      <input
                        id="index-name" name="name" type="text" required
                        className="w-full rounded-xl border border-slate-300 px-4 py-3.5 outline-none transition focus:border-invest-500 focus:ring-4 focus:ring-invest-100"
                        placeholder="Adınızı yazın"
                      />
                    </div>
                    <div>
                      <label htmlFor="index-amount" className="mb-2 block text-sm font-black text-slate-700">Salavat Adedi</label>
                      <select
                        id="index-amount" name="amount"
                        className="w-full rounded-xl border border-slate-300 bg-white px-4 py-3.5 outline-none transition focus:border-invest-500 focus:ring-4 focus:ring-invest-100"
                      >
                        <option value="100">100</option>
                        <option value="500">500</option>
                        <option value="1000">1.000</option>
                        <option value="5000">5.000</option>
                      </select>
                    </div>
                  </div>
                )}
              />

              <SalavatKart
                renk="amber"
                baslik="Hisseyi Kaldırma salavat zincirine katıl"
                aciklama="Seçtiğiniz hissenin yükselişi için oluşturulan salavat zincirine katılın."
                iconYolu="M5 19l4-5 3 2 7-10M15 6h4v4"
                katilimciSayisi="864"
                salavatSayisi="86.400"
                hedef="150.000"
                ilerlemeYuzdesi={58}
                gonderildi={hisseGonderildi}
                onSubmit={hisseZinciriGonder}
                formRef={hisseFormRef}
                butonMetni="Hisse Zincirine Katıl"
                alanlar={(
                  <>
                    <div>
                      <label htmlFor="stock-symbol" className="mb-2 block text-sm font-black text-slate-700">Hisse Kodu</label>
                      <input
                        id="stock-symbol" name="symbol" type="text" required maxLength="10"
                        className="w-full rounded-xl border border-slate-300 px-4 py-3.5 uppercase outline-none transition focus:border-amber-500 focus:ring-4 focus:ring-amber-100"
                        placeholder="Örn. THYAO"
                      />
                    </div>
                    <div className="grid gap-4 sm:grid-cols-2">
                      <div>
                        <label htmlFor="stock-name" className="mb-2 block text-sm font-black text-slate-700">Adınız Soyadınız</label>
                        <input
                          id="stock-name" name="name" type="text" required
                          className="w-full rounded-xl border border-slate-300 px-4 py-3.5 outline-none transition focus:border-amber-500 focus:ring-4 focus:ring-amber-100"
                          placeholder="Adınızı yazın"
                        />
                      </div>
                      <div>
                        <label htmlFor="stock-amount" className="mb-2 block text-sm font-black text-slate-700">Salavat Adedi</label>
                        <select
                          id="stock-amount" name="amount"
                          className="w-full rounded-xl border border-slate-300 bg-white px-4 py-3.5 outline-none transition focus:border-amber-500 focus:ring-4 focus:ring-amber-100"
                        >
                          <option value="100">100</option>
                          <option value="500">500</option>
                          <option value="1000">1.000</option>
                          <option value="5000">5.000</option>
                        </select>
                      </div>
                    </div>
                  </>
                )}
              />
            </div>

            <div className="mt-8 rounded-2xl border border-slate-200 bg-slate-50 px-5 py-4 text-sm leading-6 text-slate-600">
              Bu bölüm manevi katılım ve topluluk etkileşimi amacıyla hazırlanmıştır. Salavat zincirleri yatırım tavsiyesi,
              fiyat hedefi veya getiri taahhüdü niteliğinde değildir.
            </div>
          </div>
        </section>

        <section id="hizmetler" className="py-20 lg:py-28">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="mx-auto max-w-3xl text-center">
              <p className="text-sm font-black uppercase tracking-[0.22em] text-invest-700">Hizmetlerimiz</p>
              <h2 className="mt-4 text-3xl font-black tracking-tight text-slate-950 sm:text-4xl">
                Yatırım sürecinin her aşaması için profesyonel destek
              </h2>
              <p className="mt-5 text-lg leading-8 text-slate-600">
                Araştırmadan portföy kurgusuna, düzenli takipten yatırımcı raporlamasına kadar bütüncül bir yapı sunuyoruz.
              </p>
            </div>

            <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
              {HIZMETLER.map(hizmet => (
                <article key={hizmet.baslik} className="group rounded-3xl border border-slate-200 bg-white p-7 shadow-sm transition hover:-translate-y-2 hover:border-invest-200 hover:shadow-panel">
                  <span className={`grid h-14 w-14 place-items-center rounded-2xl transition ${hizmet.iconBg}`}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      {hizmet.yollar.map(yol => (
                        <path key={yol} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={yol} />
                      ))}
                    </svg>
                  </span>
                  <h3 className="mt-6 text-xl font-black text-slate-950">{hizmet.baslik}</h3>
                  <p className="mt-3 leading-7 text-slate-600">{hizmet.aciklama}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section id="yaklasim" className="overflow-hidden bg-slate-950 py-20 text-white lg:py-28">
          <div className="mx-auto grid max-w-7xl items-center gap-14 px-4 sm:px-6 lg:grid-cols-2 lg:px-8">
            <div>
              <p className="text-sm font-black uppercase tracking-[0.22em] text-invest-300">Yatırım Yaklaşımımız</p>
              <h2 className="mt-4 text-3xl font-black tracking-tight sm:text-4xl">
                Tek bir tahmine değil, sağlam bir karar sürecine odaklanıyoruz.
              </h2>
              <p className="mt-6 text-lg leading-8 text-slate-300">
                Yatırım kararlarını yalnızca fiyat hareketleriyle değil; şirket kalitesi, değerleme,
                sektör görünümü, makroekonomik koşullar ve portföy riskiyle birlikte değerlendiriyoruz.
              </p>

              <div className="mt-9 space-y-5">
                <div className="flex gap-4">
                  <span className="mt-1 grid h-9 w-9 shrink-0 place-items-center rounded-full bg-invest-700 font-black">1</span>
                  <div>
                    <h3 className="font-black">Temel analiz</h3>
                    <p className="mt-1 leading-7 text-slate-400">Bilanço, kârlılık, nakit akışı, borçluluk ve değerleme göstergeleri.</p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <span className="mt-1 grid h-9 w-9 shrink-0 place-items-center rounded-full bg-invest-700 font-black">2</span>
                  <div>
                    <h3 className="font-black">Teknik görünüm</h3>
                    <p className="mt-1 leading-7 text-slate-400">Trend, hacim, destek-direnç ve fiyat davranışının yardımcı gösterge olarak kullanılması.</p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <span className="mt-1 grid h-9 w-9 shrink-0 place-items-center rounded-full bg-invest-700 font-black">3</span>
                  <div>
                    <h3 className="font-black">Portföy disiplini</h3>
                    <p className="mt-1 leading-7 text-slate-400">Dağılım, çeşitlendirme, yeniden dengeleme ve risk limitlerinin düzenli takibi.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="grid gap-4 sm:grid-cols-2">
              <div className="rounded-3xl bg-white p-6 text-slate-900">
                <p className="text-xs font-black uppercase tracking-wider text-invest-700">Analiz Katmanı</p>
                <p className="mt-4 text-2xl font-black">Şirket</p>
                <p className="mt-2 leading-7 text-slate-600">Finansal yapı, büyüme, rekabet avantajı ve değerleme.</p>
              </div>

              <div className="rounded-3xl border border-white/10 bg-white/5 p-6">
                <p className="text-xs font-black uppercase tracking-wider text-invest-300">Analiz Katmanı</p>
                <p className="mt-4 text-2xl font-black">Sektör</p>
                <p className="mt-2 leading-7 text-slate-400">Döngü, rekabet, maliyet yapısı ve düzenleyici gelişmeler.</p>
              </div>

              <div className="rounded-3xl border border-white/10 bg-white/5 p-6">
                <p className="text-xs font-black uppercase tracking-wider text-invest-300">Analiz Katmanı</p>
                <p className="mt-4 text-2xl font-black">Piyasa</p>
                <p className="mt-2 leading-7 text-slate-400">Faiz, enflasyon, kur, likidite ve küresel risk iştahı.</p>
              </div>

              <div className="rounded-3xl bg-invest-700 p-6">
                <p className="text-xs font-black uppercase tracking-wider text-invest-100">Sonuç</p>
                <p className="mt-4 text-2xl font-black">Portföy</p>
                <p className="mt-2 leading-7 text-invest-100">Hedef ve risk profiline göre dengeli, izlenebilir strateji.</p>
              </div>
            </div>
          </div>
        </section>

        <section id="portfoy" className="bg-slate-50 py-20 lg:py-28">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="mx-auto max-w-3xl text-center">
              <p className="text-sm font-black uppercase tracking-[0.22em] text-invest-700">Portföy Süreci</p>
              <h2 className="mt-4 text-3xl font-black tracking-tight text-slate-950 sm:text-4xl">
                Dört aşamada yatırımcıya özel portföy yapısı
              </h2>
            </div>

            <div className="relative mt-16 grid gap-8 md:grid-cols-4">
              <div className="absolute left-[12.5%] right-[12.5%] top-8 hidden h-px bg-invest-200 md:block"></div>

              <div className="relative text-center">
                <span className="relative z-10 mx-auto grid h-16 w-16 place-items-center rounded-2xl bg-invest-700 text-xl font-black text-white shadow-lg shadow-invest-700/20">1</span>
                <h3 className="mt-6 text-lg font-black text-slate-950">Profil Analizi</h3>
                <p className="mt-3 leading-7 text-slate-600">Yatırım hedefi, süre, likidite ihtiyacı ve risk toleransı belirlenir.</p>
              </div>

              <div className="relative text-center">
                <span className="relative z-10 mx-auto grid h-16 w-16 place-items-center rounded-2xl bg-white text-xl font-black text-invest-700 ring-1 ring-invest-200">2</span>
                <h3 className="mt-6 text-lg font-black text-slate-950">Varlık Dağılımı</h3>
                <p className="mt-3 leading-7 text-slate-600">Hisse, nakit ve diğer uygun varlıklar için hedef oranlar oluşturulur.</p>
              </div>

              <div className="relative text-center">
                <span className="relative z-10 mx-auto grid h-16 w-16 place-items-center rounded-2xl bg-white text-xl font-black text-invest-700 ring-1 ring-invest-200">3</span>
                <h3 className="mt-6 text-lg font-black text-slate-950">Seçim ve Uygulama</h3>
                <p className="mt-3 leading-7 text-slate-600">Analiz sonuçlarına göre izlenecek şirketler ve giriş planı belirlenir.</p>
              </div>

              <div className="relative text-center">
                <span className="relative z-10 mx-auto grid h-16 w-16 place-items-center rounded-2xl bg-white text-xl font-black text-invest-700 ring-1 ring-invest-200">4</span>
                <h3 className="mt-6 text-lg font-black text-slate-950">Takip ve Dengeleme</h3>
                <p className="mt-3 leading-7 text-slate-600">Portföy, piyasa koşulları ve yatırımcı hedefleri doğrultusunda gözden geçirilir.</p>
              </div>
            </div>
          </div>
        </section>

        <section id="arastirma" className="py-20 lg:py-28">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
              <div className="max-w-2xl">
                <p className="text-sm font-black uppercase tracking-[0.22em] text-invest-700">Araştırma ve İçerikler</p>
                <h2 className="mt-4 text-3xl font-black tracking-tight text-slate-950 sm:text-4xl">
                  Piyasayı anlamaya yardımcı düzenli yayınlar
                </h2>
              </div>
              <a href="#" className="font-black text-invest-700 hover:text-invest-800">Tüm yayınları görüntüle →</a>
            </div>

            <div className="mt-12 grid gap-6 lg:grid-cols-3">
              {ARASTIRMALAR.map(makale => (
                <article key={makale.baslik} className="overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-sm">
                  <div className={`h-48 bg-gradient-to-br p-7 text-white ${makale.gradient}`}>
                    <span className="rounded-full bg-white/10 px-3 py-1 text-xs font-black">{makale.etiket}</span>
                    <p className="mt-12 text-2xl font-black">{makale.baslik}</p>
                  </div>
                  <div className="p-6">
                    <p className="text-sm font-bold text-slate-500">{makale.kategori}</p>
                    <p className="mt-3 leading-7 text-slate-600">{makale.aciklama}</p>
                    <a href="#" className="mt-5 inline-block font-black text-invest-700">İncele →</a>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section id="sss" className="bg-slate-50 py-20 lg:py-28">
          <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <p className="text-sm font-black uppercase tracking-[0.22em] text-invest-700">Sık Sorulan Sorular</p>
              <h2 className="mt-4 text-3xl font-black text-slate-950 sm:text-4xl">Merak edilenler</h2>
            </div>

            <div className="mt-12 space-y-4">
              {SSS.map(soru => (
                <details key={soru.soru} className="group rounded-2xl border border-slate-200 bg-white p-6">
                  <summary className="flex cursor-pointer list-none items-center justify-between gap-4 font-black text-slate-950">
                    {soru.soru}
                    <span className="text-xl text-invest-700 transition group-open:rotate-45">+</span>
                  </summary>
                  <p className="mt-4 leading-7 text-slate-600">{soru.cevap}</p>
                </details>
              ))}
            </div>
          </div>
        </section>

        <section id="iletisim" className="px-4 py-20 sm:px-6 lg:px-8 lg:py-28">
          <div className="relative mx-auto max-w-7xl overflow-hidden rounded-[2rem] bg-invest-700 px-6 py-14 shadow-2xl shadow-invest-700/20 sm:px-10 lg:px-16 lg:py-16">
            <div className="absolute -right-20 -top-24 h-72 w-72 rounded-full bg-white/10"></div>
            <div className="absolute -bottom-32 -left-20 h-80 w-80 rounded-full bg-cyan-300/20"></div>

            <div className="relative grid items-center gap-10 lg:grid-cols-[1.05fr_0.95fr]">
              <div>
                <p className="font-black text-invest-100">Ön görüşme talebi</p>
                <h2 className="mt-3 text-3xl font-black tracking-tight text-white sm:text-4xl">
                  Yatırım hedeflerinizi birlikte değerlendirelim.
                </h2>
                <p className="mt-5 max-w-2xl text-lg leading-8 text-invest-100">
                  Kısa formu doldurun. Risk profiliniz, yatırım süreniz ve beklentileriniz hakkında ön görüşme planlayalım.
                </p>

                <div className="mt-8 space-y-3 text-sm font-bold text-white">
                  <p>Telefon: +90 850 850 80 50</p>
                  <p>E-posta: bilgi@kaldir.com.tr</p>
                  <p>Adres: Fatih/İstanbul</p>
                </div>
              </div>

              <form ref={iletisimFormRef} onSubmit={iletisimGonder} className="rounded-3xl bg-white p-6 shadow-xl sm:p-8">
                <div className="grid gap-5">
                  <div>
                    <label htmlFor="name" className="mb-2 block text-sm font-black text-slate-700">Adınız Soyadınız</label>
                    <input id="name" name="name" type="text" required className="w-full rounded-xl border border-slate-300 px-4 py-3.5 outline-none transition focus:border-invest-500 focus:ring-4 focus:ring-invest-100" placeholder="Adınızı yazın" />
                  </div>

                  <div>
                    <label htmlFor="phone" className="mb-2 block text-sm font-black text-slate-700">Telefon Numaranız</label>
                    <input id="phone" name="phone" type="tel" required className="w-full rounded-xl border border-slate-300 px-4 py-3.5 outline-none transition focus:border-invest-500 focus:ring-4 focus:ring-invest-100" placeholder="05xx xxx xx xx" />
                  </div>

                  <div>
                    <label htmlFor="profile" className="mb-2 block text-sm font-black text-slate-700">Yatırım Deneyiminiz</label>
                    <select id="profile" name="profile" className="w-full rounded-xl border border-slate-300 bg-white px-4 py-3.5 outline-none transition focus:border-invest-500 focus:ring-4 focus:ring-invest-100">
                      <option>Yeni yatırımcıyım</option>
                      <option>1-3 yıl deneyimliyim</option>
                      <option>3 yıldan fazla deneyimliyim</option>
                      <option>Kurumsal yatırımcıyım</option>
                    </select>
                  </div>

                  <div>
                    <label htmlFor="service" className="mb-2 block text-sm font-black text-slate-700">İlgilendiğiniz Hizmet</label>
                    <select id="service" name="service" className="w-full rounded-xl border border-slate-300 bg-white px-4 py-3.5 outline-none transition focus:border-invest-500 focus:ring-4 focus:ring-invest-100">
                      <option>BİST hisse takibi</option>
                      <option>Portföy oluşturma</option>
                      <option>Yatırım danışmanlığı</option>
                      <option>Şirket ve sektör analizi</option>
                    </select>
                  </div>

                  <label className="flex items-start gap-3 text-xs leading-5 text-slate-500">
                    <input type="checkbox" required className="mt-1 rounded border-slate-300 text-invest-700 focus:ring-invest-500" />
                    <span>İletişim kurulması ve kişisel verilerimin bu amaçla işlenmesi için bilgilendirme metnini okudum.</span>
                  </label>

                  <button type="submit" className="inline-flex items-center justify-center rounded-xl bg-slate-950 px-6 py-4 font-black text-white transition hover:bg-invest-800">
                    Ön Görüşme Talebi Gönder
                  </button>

                  {iletisimGonderildi && (
                    <p className="rounded-xl bg-emerald-50 px-4 py-3 text-sm font-bold text-emerald-700">
                      Talebiniz alınmıştır. En kısa sürede sizinle iletişime geçilecektir.
                    </p>
                  )}
                </div>
              </form>
            </div>
          </div>
        </section>
      </main>

      <footer className="bg-slate-950 text-white">
        <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-4 lg:px-8">
          <div className="md:col-span-2">
            <a href="#anasayfa" className="flex items-center gap-3">
              <span className="grid h-11 w-11 place-items-center rounded-2xl bg-invest-700 text-white">
                <Logo className="h-6 w-6" />
              </span>
              <span>
                <span className="block font-black">Kaldır Yatırım</span>
                <span className="text-xs font-bold uppercase tracking-[0.16em] text-invest-300">Danışmanlık</span>
              </span>
            </a>

            <p className="mt-5 max-w-xl leading-7 text-slate-400">
              BİST hisse senedi takibi, şirket analizi, yatırımcı risk profili değerlendirmesi ve portföy stratejileri.
            </p>
          </div>

          <div>
            <h3 className="font-black">Kurumsal</h3>
            <div className="mt-4 flex flex-col gap-3 text-sm font-semibold text-slate-400">
              <a href="#yaklasim" className="hover:text-invest-300">Yatırım Yaklaşımı</a>
              <a href="#hizmetler" className="hover:text-invest-300">Hizmetler</a>
              <a href="#arastirma" className="hover:text-invest-300">Araştırma</a>
              <a href="#iletisim" className="hover:text-invest-300">İletişim</a>
            </div>
          </div>

          <div>
            <h3 className="font-black">Yasal</h3>
            <div className="mt-4 flex flex-col gap-3 text-sm font-semibold text-slate-400">
              <a href="#" className="hover:text-invest-300">KVKK Aydınlatma Metni</a>
              <a href="#" className="hover:text-invest-300">Gizlilik Politikası</a>
              <a href="#" className="hover:text-invest-300">Risk Bildirim Formu</a>
              <a href="#" className="hover:text-invest-300">Çerez Politikası</a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10">
          <div className="mx-auto flex max-w-7xl flex-col gap-3 px-4 py-6 text-sm text-slate-500 sm:px-6 md:flex-row md:items-center md:justify-between lg:px-8">
            <p>© {new Date().getFullYear()} Kaldır Yatırım Danışmanlık. Tüm hakları saklıdır.</p>
            <p>Arayüz taslağı — gerçek veriler ve kurumsal bilgiler entegrasyonla eklenecektir.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Home
